export default __webpack_public_path__ + "static/media/compass.89077945.png";